<template>
  <div class="min-h-screen bg-background text-text">
    <router-view />
    <!-- ✅ Overlay global -->
    <Overlay :visible="overlayVisible" @close="overlayVisible = false">
      <component :is="overlayContent" v-bind="overlayProps" @close="overlayVisible = false" />
    </Overlay>
  </div>
</template>

<script setup>
import { ref, provide } from 'vue'
import Overlay from '@/components/ui/OverlayComponent.vue'
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/authStore'

const overlayVisible = ref(false)
const overlayContent = ref(null) // composant à afficher
const overlayProps = ref({}) // props à passer au composant

function openOverlay(component, props = {}) {
  overlayContent.value = component
  overlayProps.value = props
  overlayVisible.value = true
}

function closeOverlay() {
  overlayVisible.value = false
}

provide('openOverlay', openOverlay)
provide('closeOverlay', closeOverlay)

const authStore = useAuthStore()

onMounted(() => {
  authStore.initAuth()  // OK, Pinia est actif maintenant
})
</script>

<style></style>
